import React from 'react';

const StudyReportsPage: React.FunctionComponent<any> = () => {
  return (
    <div>
      <h3>Study Reports Page</h3>
    </div>
  );
};

export default StudyReportsPage;
